/**
 * Created by tdunham on 6/26/2017.
 */

export class News {

	public id:             number;      // The ID of the story in the Angular ReST API.
	public title:          string;      // The title of the story.
	public body:           string;      // The story content.
	public fantasy_tip:    string;      // The "tip" content of the story for fantasy sports.
	public huddle_tip:     string;      // The "tip" content of the story for the huddle.
	public baseball_tip:   string;      // The "tip" content of the story for baseball.
	public code:           string;      // Which sport? (Example: "NFL")
	public visible:        number;      // 2 if published in the future, 1 if this story is published, 0 if draft, -1 if trash.
	public date:           Date;        // The date of publication for this story.
	public hot:            number;      // 1 if this story is breaking news; 0 otherwise.
	public image:          string;      // Image URL.
	public original_url:   string;      // The URL of the story this item is based on.
	public source_id:      number;      // The ID of the original source writer of this story from the "source" table.
	public user_id:        number;      // The user.id field of the person who wrote this article.

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/news/news.ts